import { Box, Typography } from "@mui/material";
import KsbActionButton from "../../../../2_ksbHub/components/KsbActionButton";
import { DeleteIcon, EditIcon } from "../../../../2_ksbHub/icons/icons";
import { useTheme } from "@mui/material/styles";
import { useAppContext } from "../../../../2_ksbHub/context/appContext";

export default function TeacherWorkloadRow({ teacher, onEdit, onDelete }) {
  const theme = useTheme();
  const { isMobile } = useAppContext();
  function formatAbbr(abbr) {
    if (!abbr) return "";

    const clean = abbr.trim().toLowerCase();

    return (
      clean[0].toUpperCase() +
      clean.slice(1, -1) +
      clean[clean.length - 1].toUpperCase()
    );
  }
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
        py: 1,
        px: 1,
        borderBottom: "1px solid",
        borderColor: "divider",
      }}
    >
      <Box
        sx={{
          px: 1,
          py: 0.25,
          borderRadius: 1,
          bgcolor: "primary.main",
          color: "white",
          minWidth: 42,
          textAlign: "center",
        }}
      >
        <Typography variant="caption" fontWeight={700}>
          {formatAbbr(teacher.abbreviation)}
        </Typography>
      </Box>
      {!isMobile && (
        <Typography
          variant="body2"
          fontWeight={200}
          sx={{
            flexGrow: 1,
          }}
        >
          {teacher.name}
        </Typography>
      )}
      <Typography
        variant="body2"
        fontWeight={600}
        sx={{
          minWidth: 50,
          textAlign: "right",
        }}
      >
        {(Number(teacher.workload) * 100).toFixed(0)}%
      </Typography>
      <KsbActionButton
        onClick={(e) => {
          e.stopPropagation(); // ✅ prevents RoomDialog
          onEdit(teacher);
        }}
        icon={<EditIcon />}
        label="bearbeiten"
        size="small"
        sx={{
          bgcolor: theme.palette.primary.main,
          "&:hover": { bgcolor: theme.palette.primary.dark },
        }}
      />
      <KsbActionButton
        onClick={() => onDelete(teacher)}
        icon={<DeleteIcon />}
        label="Löschen"
        size="small"
        confirm={{
          title: "Lehrperson löschen?",
          message: "Soll diese Lehrperson wirklich gelöscht werden?",
        }}
        sx={{
          bgcolor: theme.palette.error.main,
          color: theme.palette.error.contrastText,
          "&:hover": { bgcolor: theme.palette.error.dark },
        }}
      />
    </Box>
  );
}
